import React, { FC } from 'react';

import { ResponsiveCarousel } from 'components/responsive-carousel';

import { RecentOrderCardCarouselContainer } from './recent-order-card-carousel.styled';

export interface ICardCarouselProps {
  children: React.ReactNode[];
  bgColor?: string;
}

const RecentOrderCardCarousel: FC<ICardCarouselProps> = ({ children, bgColor }) => (
  <RecentOrderCardCarouselContainer>
    <ResponsiveCarousel bgColor={bgColor}>{children}</ResponsiveCarousel>
  </RecentOrderCardCarouselContainer>
);

export default RecentOrderCardCarousel;
